import { SegmentedControl } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { LANGUAGES } from '@/i18n';
import { useLang } from '@/i18n/useLang';

/** RU/EN toggle; the choice is remembered per browser (see `i18n/index.ts`). */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  const lang = useLang();
  return (
    <SegmentedControl
      size="xs"
      value={lang}
      onChange={(value) => void i18n.changeLanguage(value)}
      data={LANGUAGES.map((language) => ({ value: language, label: t(`language.${language}`) }))}
      aria-label={t('language.label')}
    />
  );
}
